import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators  } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from '../shared/admin/admin.service';
import { CustomerService } from '../shared/customer/customer.service';
import { ModeratorService } from '../shared/moderator/moderator.service';
import { ExpertService } from '../shared/techExpert/expert.service';
import { LoginService } from '../shared/user-login/login.service';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.css'],
    standalone: false
})
export class ContactComponent implements OnInit {

 ngOnInit(): void {
  //console.log('Inside About us OnInit')
  }

  
}

